import PropTypes from 'prop-types';
import { useState } from 'react';
import { connect } from 'react-redux';

import VisitorTableComponent from './VisitorTableComponent';

import { getBuildingsForFilter } from '../Building/actionCreators';
import { syncPerson } from '../BuildingSettings/actions/syncActions';
import { syncWithBrivo } from '../Person/actions';
import { getUnitsWithContacts } from '../Unit/actionCreators';
import {
  clearInviteInfo,
  deleteInvite,
  expireVisitor,
  getVisitorsList,
  logVisitorEntry,
  sendInvite,
  updateInviteInfo,
} from './actionCreators';

import { getTodayCount } from '../../utils';

const LIST_KEY = 'visitors';

const getInitialInviteModalData = () => ({
  buildingId: null,
  visitor: null,
  isInviteUpdate: false,
});

const VisitorTableContainer = (props) => {
  const {
    sendInvite,
    updateInvite,
    listParams,
    onGetVisitorsList,
    clearInviteInfo,
  } = props;

  const [isInviteModalShown, setIsInviteModalShown] = useState(false);
  const [inviteModalData, setInviteModalData] = useState(
    getInitialInviteModalData(),
  );

  const onShowInviteModal = (visitor, isInviteUpdate) => {
    setIsInviteModalShown(true);
    setInviteModalData({
      visitor,
      buildingId: visitor?.building,
      isInviteUpdate,
    });
  };

  const onCloseInviteModal = () => {
    setIsInviteModalShown(false);
    setInviteModalData(getInitialInviteModalData());
    clearInviteInfo();
  };

  const onSendInvite = (data) => {
    const { visitor, isInviteUpdate } = inviteModalData;
    if (isInviteUpdate) {
      updateInvite(visitor?.id, data);
    } else {
      sendInvite(data, visitor?.id, false, listParams);
    }
    onCloseInviteModal();
  };

  const onExport = (paginationParams) => {
    const queryParams = { ...listParams, ...paginationParams };
    return onGetVisitorsList(queryParams);
  };

  const visitorsProps = {
    ...props,
    inviteModalData,
    isInviteModalShown,
    onShowInviteModal,
    onCloseInviteModal,
    onSendInvite,
    onExport,
  };
  return <VisitorTableComponent {...visitorsProps} />;
};

const mapStateToProps = (state) => {
  const { visitors, buildings, common, lists, units } = state;
  return {
    items: visitors,
    listKey: LIST_KEY,
    listParams: lists?.[LIST_KEY] || {},
    buildings,
    user: common?.currentUser,
    units,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onLoad: (params) => getBuildingsForFilter(dispatch, params),
  getItems: (queryParams = {}) => {
    getVisitorsList(dispatch, queryParams);
    getTodayCount(getVisitorsList, dispatch, queryParams);
  },
  onGetVisitorsList: (queryParams) =>
    getVisitorsList(dispatch, queryParams, true),

  sendInvite: (data, visitorId, hasInvite, queryParams) =>
    sendInvite(dispatch, data, visitorId, hasInvite, queryParams),
  updateInvite: (visitorId, data) =>
    updateInviteInfo(dispatch, visitorId, data),
  deleteInvite: (visitorId, queryParams) =>
    deleteInvite(dispatch, visitorId, queryParams),
  clearInviteInfo: () => clearInviteInfo(dispatch),

  expireVisitor: (visitorId, queryParams) =>
    expireVisitor(dispatch, visitorId, queryParams),

  syncWithBrivo: (buildingId, personId, queryParams) => {
    syncWithBrivo(dispatch, buildingId, personId).then(() =>
      getVisitorsList(dispatch, queryParams),
    );
  },
  syncPerson: (buildingId, personId, accountType) =>
    syncPerson(dispatch, buildingId, personId, accountType),
  onLogEntry: (visitorId) => logVisitorEntry(dispatch, visitorId),
  getUnits: (buildingId) => getUnitsWithContacts(dispatch, buildingId),
});

VisitorTableContainer.defaultProps = {
  building: {},
  pmc: {},
};

VisitorTableContainer.propTypes = {
  sendInvite: PropTypes.func.isRequired,
  updateInvite: PropTypes.func.isRequired,
  clearInviteInfo: PropTypes.func.isRequired,
  onGetVisitorsList: PropTypes.func.isRequired,
  listParams: PropTypes.instanceOf(Object).isRequired,
  building: PropTypes.instanceOf(Object),
  pmc: PropTypes.instanceOf(Object),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(VisitorTableContainer);
